import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import viewReadyTracker from '../../services/ViewReadyTracker';
import styles from './options.scss';

class OptionsWrapper extends React.Component {
    static propTypes = {
        children: PropTypes.object,
        currentlyShown: PropTypes.object.isRequired,
    };

    componentDidMount() {
        viewReadyTracker.getReporter()(true);
    }

    // eslint-disable-next-line camelcase,react/sort-comp
    UNSAFE_componentWillUpdate(nextProps) {
        if (nextProps.currentlyShown !== this.props.currentlyShown) {
            this.shouldReportReady = true;
        }
    }

    componentDidUpdate() {
        if (this.shouldReportReady) {
            viewReadyTracker.getReporter()(true);
            this.shouldReportReady = false;
        }
    }

    render() {
        return (
            <div className={styles.candidateOptions}>
                {this.props.children}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        currentlyShown: state.currentlyShown,
    };
}

const OptionsContainer = connect(mapStateToProps)(OptionsWrapper);
export default OptionsContainer;
